import { asyncRoutes, constantRoutes } from '@/router/index'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roleId, route) {
  if (route.meta && route.meta.roles) {
    // return route.meta.roles.includes(roleId) || route.meta.roles.includes(roleId.toString())
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roleId) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roleId, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roleId)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: [],
  isLoginHandled: false,
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
  SET_LOGIN_HANDLED(state, value) {
    state.isLoginHandled = value;
  },
}

const actions = {
  generateRoutes({ commit, state }, roleId ) {
    // console.log(roleId)
    return new Promise(resolve => {
      let accessedRoutes = []
      accessedRoutes = filterAsyncRoutes(asyncRoutes, roleId)
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },
  resetLoginHandled({ commit }) {
    commit('SET_LOGIN_HANDLED', false);
  },
  loginHandled({ commit }) {
    // console.log("调用调用");
    commit('SET_LOGIN_HANDLED', true);
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
